
  import { defineComponent, PropType } from 'vue';
  import { createColumnHelper } from '@tanstack/vue-table';

  import TableAggregated from '@/common/components/redesigned/Table/TableAggregated.vue';
  import textMixin from '@/common/mixins/text';
  import { TStorePaths } from '@/common/types/storePaths';

  import {
    ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME,
    ANALYTICS_NOTES_MONTHLY_GETTERS_NAME,
    ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME,
  } from '../../store/analyticsNotesMonthly/name';
  import {
    ANALYTICS_NOTES_YEARLY_ACTIONS_NAME,
    ANALYTICS_NOTES_YEARLY_GETTERS_NAME,
    ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME,
  } from '../../store/analyticsNotesYearly/name';
  import {
    TAnalyticsNotesFilter,
    TAnalyticsNotesForeignTradeTable,
    TAnalyticsNotesForeignTradeTableItem,
  } from '../../types/analytics-notes';

  export default defineComponent({
    name: 'AnalyticsNotesForeignTradeTable',
    components: {
      TableAggregated,
    },
    mixins: [textMixin],
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      storePaths(): TStorePaths {
        return this.isMonthly
          ? {
              action: ANALYTICS_NOTES_MONTHLY_ACTIONS_NAME.searchForeignTradeTable,
              getter: ANALYTICS_NOTES_MONTHLY_GETTERS_NAME.getForeignTradeTable,
              mutation: ANALYTICS_NOTES_MONTHLY_MUTATIONS_NAME.setForeignTradeTable,
            }
          : {
              action: ANALYTICS_NOTES_YEARLY_ACTIONS_NAME.searchForeignTradeTable,
              getter: ANALYTICS_NOTES_YEARLY_GETTERS_NAME.getForeignTradeTable,
              mutation: ANALYTICS_NOTES_YEARLY_MUTATIONS_NAME.setForeignTradeTable,
            };
      },
    },
    methods: {
      generateColumns(data: TAnalyticsNotesForeignTradeTable) {
        if (!data) return [];

        const columnHelper = createColumnHelper<TAnalyticsNotesForeignTradeTableItem>();

        return [
          // Поставил игнорирования из-за того, что в браузере вылезает ошибка типа (после обновления ts должна уйти)
          // @ts-ignore
          columnHelper.accessor((row: TAnalyticsNotesForeignTradeTableItem) => row.indicator, {
            id: 'indicator',
            header: 'Показатель',
            maxSize: 108,
          }),
          ...data.periods.map((period, index) => {
            return columnHelper.accessor(
              (row: TAnalyticsNotesForeignTradeTableItem) => this.formatNumber(row.values[index], 1, ' ', ','),
              {
                header: period,
                id: `period-${index}`,
                size: 160,
              },
            );
          }),
        ];
      },
    },
  });
